import relative from './relative'

export { relative }